<div>
  <form [formGroup]="destinationFormGroup()">
    <mat-form-field (click)="departureDate.open()" color="accent" appearance="fill">
      <mat-label>
        {{ 'USER.REVIEWED_REQUESTS.START_DATE' | translate }}
      </mat-label>
      <input
        matInput
        [matDatepicker]="departureDate"
        (dateInput)="getStartDate($event)"
        required
        formControlName="departureDate"
      />
      <mat-datepicker-toggle matSuffix [for]="departureDate"></mat-datepicker-toggle>
      <mat-datepicker #departureDate color="primary"></mat-datepicker>
    </mat-form-field>
    <mat-form-field (click)="returnDate.open()" color="accent" appearance="fill">
      <mat-label>
        {{ 'USER.REVIEWED_REQUESTS.END_DATE' | translate }}
      </mat-label>
      <input
        matInput
        [min]="minDate"
        [matDatepicker]="returnDate"
        required
        formControlName="returnDate"
      />
      <mat-datepicker-toggle matSuffix [for]="returnDate"></mat-datepicker-toggle>
      <mat-datepicker #returnDate color="primary"></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>
        {{ 'USER.TRAVEL_REQUESTS.FROM_CITY' | translate }}
      </mat-label>
      <input matInput type="text" formControlName="fromCity" required />
      @if (destinationFormGroup().controls.fromCity.invalid) {
        <mat-error>{{ getErrorMessage() }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>
        {{ 'USER.TRAVEL_REQUESTS.FROM_COUNTRY' | translate }}
      </mat-label>
      <input
        matInput
        formControlName="fromCountry"
        [matAutocomplete]="autoFrom"
        required
        #filterFrom
      />
      <mat-autocomplete #autoFrom="matAutocomplete">
        @for (country of allCountries | filter: filterFrom.value : 'countryName'; track country) {
          <mat-option [value]="country.countryName">
            {{ country.countryName }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (destinationFormGroup().controls.fromCountry.invalid) {
        <mat-error>{{ getErrorMessage() }} </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>
        {{ 'USER.TRAVEL_REQUESTS.TO_CITY' | translate }}
      </mat-label>
      <input matInput type="text" formControlName="toCity" required />
      @if (destinationFormGroup().controls.toCity.invalid) {
        <mat-error>{{ getErrorMessage() }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>
        {{ 'USER.TRAVEL_REQUESTS.TO_COUNTRY' | translate }}
      </mat-label>
      <input matInput formControlName="toCountry" [matAutocomplete]="autoTo" required #filterTo />
      <mat-autocomplete #autoTo="matAutocomplete">
        @for (country of allCountries | filter: filterTo.value : 'countryName'; track country) {
          <mat-option [value]="country.countryName">
            {{ country.countryName }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (destinationFormGroup().controls.toCountry.invalid) {
        <mat-error>{{ getErrorMessage() }} </mat-error>
      }
    </mat-form-field>
    @if (length() === 1) {
      <div class="radio-buttons-container">
        <mat-radio-group
          [(ngModel)]="isRoundTrip"
          [ngModelOptions]="{ standalone: true }"
          class="radio-buttons-container"
          required
          (change)="emitRoundTripChange($event.value)"
          [disabled]="mode === componentModeEnum.VIEW && !isAdmin()"
        >
          <label>{{ 'USER.REIMBURSEMENT_REQUESTS.ROUND_TRIP' | translate }}</label>
          <div>
            <mat-radio-button color="primary" [value]="true">{{
              'USER.OVERTIME.REQUEST_FORM.YES' | translate
            }}</mat-radio-button>
            <mat-radio-button color="primary" [value]="false">{{
              'USER.OVERTIME.REQUEST_FORM.NO' | translate
            }}</mat-radio-button>
          </div>
        </mat-radio-group>
        @if (isRoundTrip() === null) {
          <mat-error class="radio-button-error">{{ getErrorMessage('radio-buttons') }}</mat-error>
        }
      </div>
    }

    @if (length() !== 1) {
      <mat-icon class="delete-icon" (click)="deleteRow()">cancel</mat-icon>
    }
  </form>
</div>
